import { useState } from "react";
import { useTheme, colorPresets } from "../contexts/ThemeContext";
import { Button } from "./ui/button";
import { Palette, Check, Sun, Moon } from "lucide-react";

export function FloatingPresetButton() {
  const { theme, toggleTheme, colorPreset, setColorPreset } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const presetColors = {
    electric: "bg-red-500",
    ocean: "bg-blue-500",
    forest: "bg-emerald-500",
  };

  return (
    // On mobile: lift above the iOS bottom nav (≈4rem) + safe area + extra 8px gap
    // On desktop: keep original bottom-6
    <div className="fixed z-50 flex flex-col items-start gap-2
      bottom-[calc(4rem+env(safe-area-inset-bottom,0px)+0.5rem)] left-6
      lg:bottom-6">

      {/* Preset Options (slide up when open) */}
      <div className={`flex flex-col gap-2 transition-all duration-300 ${isOpen ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}>
        {/* Dark / Light toggle */}
        <Button
          size="icon"
          variant="secondary"
          className="h-10 w-10 rounded-full shadow-lg border border-border"
          onClick={toggleTheme}
          data-testid="floating-theme-toggle"
        >
          {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>

        {/* Color presets */}
        {Object.entries(colorPresets).map(([key]) => (
          <Button
            key={key}
            size="icon"
            variant="secondary"
            className="h-10 w-10 rounded-full shadow-lg border border-border relative overflow-hidden"
            onClick={() => setColorPreset(key)}
            data-testid={`preset-${key}`}
          >
            <div className={`absolute inset-2 rounded-full ${key === "electric" ? "bg-red-500" : key === "ocean" ? "bg-blue-500" : "bg-emerald-500"
              }`} />
            {colorPreset === key && (
              <Check className="h-4 w-4 relative z-10 text-white drop-shadow-md" />
            )}
          </Button>
        ))}
      </div>

      {/* Main toggle */}
      <Button
        size="icon"
        className={` h-8 w-8 md:h-12 md:w-12 rounded-full shadow-xl border-2 border-primary/20 transition-transform duration-300 ${isOpen ? "rotate-180" : ""
          }`}
        onClick={() => setIsOpen(o => !o)}
        data-testid="floating-preset-btn"
      >
        <Palette className="h-5 w-5" />
      </Button>
    </div>
  );
}
